import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Modal, Form } from 'semantic-ui-react'
import {
    FormTextFormField,
    FormDropdownField,
    FormCheckBoxField,
    SubmitCancelButtons,
} from 'elements'
import { FlexRowBetween } from 'components'
import { X } from 'phosphor-react'

const CustomFieldSchema = yup.object().shape({
    fieldName: yup.string().required('Field Name is required'),
    fieldType: yup.string().required('Field Type is required'),
    entityType: yup.string().required('Entity Type is required'),
    description: yup.string().nullable(),
    required: yup.boolean(),
})

const fieldTypeOptions = [
    { key: 'text', text: 'Text', value: 'text' },
    { key: 'number', text: 'Number', value: 'number' },
    { key: 'textarea', text: 'Text Area', value: 'textarea' },
    { key: 'date', text: 'Date', value: 'date' },
    { key: 'datetime', text: 'Date Time', value: 'datetime' },
    { key: 'dropdown', text: 'Dropdown', value: 'dropdown' },
    { key: 'checkbox', text: 'Checkbox', value: 'checkbox' },
]

const entityTypeOptions = [
    { key: 'asset', text: 'Asset', value: 'asset' },
    { key: 'customer', text: 'Customer', value: 'customer' },
    { key: 'template', text: 'Template', value: 'template' },
    { key: 'task', text: 'Task', value: 'task' },
    { key: 'inspection', text: 'Inspection', value: 'inspection' },
]

export const CustomFieldAddEditModal = ({
    open,
    onClose,
    data,
    loading,
}) => {
    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(CustomFieldSchema),
        defaultValues: {
            fieldName: '',
            fieldType: '',
            entityType: '',
            description: '',
            required: false,
        },
    })

    useEffect(() => {
        if (data && data.id) {
            reset({
                fieldName: data.fieldName || '',
                fieldType: data.fieldType || '',
                entityType: data.entityType || '',
                description: data.description || '',
                required: data.required || false,
            })
        } else {
            reset({
                fieldName: '',
                fieldType: '',
                entityType: '',
                description: '',
                required: false,
            })
        }
    }, [data, reset])

    const submit = async (formData) => {
        await onClose(formData)
    }

    const handleCancel = () => {
        reset()
        onClose(null)
    }

    return (
        <Modal open={open} onClose={handleCancel} size="small">
            <Modal.Header>
                <FlexRowBetween>
                    <div style={{ fontWeight: 600, fontSize: '18px' }}>
                        {data?.id ? 'Edit Custom Field' : 'Add Custom Field'}
                    </div>
                    <X
                        className="pointer"
                        size={24}
                        onClick={handleCancel}
                    />
                </FlexRowBetween>
            </Modal.Header>
            <Modal.Content>
                <Form noValidate>
                    <Form.Group>
                        <FormTextFormField
                            control={control}
                            name="fieldName"
                            label="Field Name"
                            placeholder="Enter field name"
                            errors={errors.fieldName}
                            required
                        />
                    </Form.Group>
                    <Form.Group widths="equal">
                        <FormDropdownField
                            control={control}
                            name="fieldType"
                            label="Field Type"
                            placeholder="Select field type"
                            errors={errors.fieldType}
                            options={fieldTypeOptions}
                            required
                        />
                        <FormDropdownField
                            control={control}
                            name="entityType"
                            label="Entity Type"
                            placeholder="Select entity type"
                            errors={errors.entityType}
                            options={entityTypeOptions}
                            required
                        />
                    </Form.Group>
                    <Form.Group>
                        <FormTextFormField
                            control={control}
                            name="description"
                            label="Description"
                            placeholder="Enter description (optional)"
                            errors={errors.description}
                        />
                    </Form.Group>
                    <Form.Group>
                        <FormCheckBoxField
                            control={control}
                            name="required"
                            label="Required Field"
                            errors={errors.required}
                        />
                    </Form.Group>
                    <div className="pt-1">
                        <SubmitCancelButtons
                            onSubmit={handleSubmit(submit)}
                            onCancel={handleCancel}
                            loading={loading}
                        />
                    </div>
                </Form>
            </Modal.Content>
        </Modal>
    )
}
